import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { IWatchMock } from '../mock-data/models/IWatchMock';
import { mockWatches } from '../mock-data/watch.mock';
export interface WatchFilters {
  name?: string;
  brand?: string;
  minPrice?: number;
  maxPrice?: number;
  condition?: string;
  marketStatus?: string;
}

@Injectable({
  providedIn: 'root'
})

export class WatchMockService {

  constructor() {}

  // Método para obtener los relojes simulando una API con delay
  getWatches(filters?: WatchFilters, limit: number = 5): Observable<IWatchMock[]> {
    return of(mockWatches).pipe(
      delay(1000), // Simula retardo de API
      map(watches => this.applyFilters(watches, filters)), // Aplica los filtros
      map(watches => watches.slice(0, limit)) // Limita resultados
    );
  }

  private applyFilters(watches: IWatchMock[], filters?: WatchFilters): IWatchMock[] {
    if (!filters) return watches;

    return watches.filter(watch => {
      const brandName = watch.brand?.name?.toLowerCase() ?? ''; // Evita error si `brand` es undefined
      const watchName = watch.name?.toLowerCase() ?? '';
      const watchPrice = watch.price ?? 0;

      return (!filters.name || watchName.includes(filters.name.toLowerCase())) &&
             (!filters.brand || brandName.includes(filters.brand.toLowerCase())) &&
             (!filters.minPrice || watchPrice >= filters.minPrice) &&
             (!filters.maxPrice || watchPrice <= filters.maxPrice) &&
             (!filters.condition || watch.condition === filters.condition) &&
             (!filters.marketStatus || watch.marketStatus === filters.marketStatus);
    });
  }
  // Método para obtener un reloj por ID
  getWatchById(id: number): Observable<IWatchMock | undefined> {
    return of(mockWatches.find(watch => watch.id === id)).pipe(delay(500));
  }

  private getData(): Observable<IWatchMock[]> {
    return of(mockWatches);
  }

  createWatch(watch: IWatchMock): Observable<IWatchMock> {
    return of(watch).pipe(delay(500)); // Simula la creación del reloj
  }

  updateWatch(id: number, watch: IWatchMock): Observable<IWatchMock> {
    return of(watch).pipe(delay(500)); // Simula la actualización del reloj
  }

  deleteWatch(id: number): Observable<void> {
    return of(undefined).pipe(delay(500)); // Simula la eliminación del reloj
  }
}
